export default __webpack_public_path__ + "static/media/img-1.596896b8.png";